import styled from 'styled-components';

export const Wrap = styled.div`
  min-width: 960px;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: ${({ isAdvertiser }) => (isAdvertiser ? '1fr 336px' : '1fr')};
  gap: 32px;
  min-height: 200px;
  margin-bottom: 32px;
`;
